import ScrollableTable from "./TableLiteScrollable";

export default ScrollableTable;
